// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"FarmSettings_loadingOverlay__Gpk-l","linkButton":"FarmSettings_linkButton__m0k9+"};